import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CustomCheckoutSettingsModel, CustomGeneralSettingsModel, CustomStockSettingsModel, LaunchDarklySettingsModel, ShowMiniCartSettingModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowShippingSettingSettingModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowForeignStockInCountryModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowVendorStocksModel } from "@MasterBluePrint/Types/ApiModels";
import { Stripe3DSSettingsModel } from "@MasterBluePrint/Types/ApiModels";

export function getShowShippingAndTaxSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showTaxAndShippingInCheckoutShipping as ShowShippingSettingSettingModel | undefined;
}

export function getShowMiniCartSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showMiniCart as ShowMiniCartSettingModel | undefined;
}

export function showForeignStockMessageSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showForeignStockInCountry as ShowForeignStockInCountryModel | undefined;
}

export function showVendorStocksSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showVendorStocks as ShowVendorStocksModel | undefined;
}

export function getStripe3DSSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.stripe3DSSettings as Stripe3DSSettingsModel | undefined;
}

export function getCustomStockSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.customStockSettings as CustomStockSettingsModel | undefined;
}

export function getCustomGeneralSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.customGeneralSettings as CustomGeneralSettingsModel | undefined;
}

export function getLaunchDarklySettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.launchDarklySettings as LaunchDarklySettingsModel;
}

export function getCustomCheckoutSettings(state: ApplicationState){
    return state.context.settings.settingsCollection.customCheckoutSettings as CustomCheckoutSettingsModel | undefined;
}